'use client';
import React from 'react';

import dynamic from 'next/dynamic';
import PikAppLogo from '@/public/pik-app.png';

const BasicDeepLink = dynamic(() => import('../helper/DeepLink'), {
  ssr: false,
});

import { Button } from '../ui/button';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

const DownloadApp = () => {
  const t = useTranslations('search');
  return (
    <section
      className="bg-logo-start direction-alternate order-6 mt-6 hidden h-[600px] w-full grid-cols-2 items-center justify-items-center rounded-lg lg:grid"
      style={{ direction: 'ltr' }}
    >
      <div className="flex h-full w-full items-center justify-start px-10">
        <div>
          <h1 className="mb-3 text-5xl leading-normal font-bold tracking-wide text-white">
            {t('ExclusiveDealsLine1')}
            <br />
            {t('ExclusiveDealsLine2')}
          </h1>
          <BasicDeepLink>
            <Button
              variant={'secondary'}
              style={{ maxWidth: '60%' }}
              className="mt-4 w-4/6 rounded-xl bg-[#F9F3FF]"
            >
              <span className="text-lg font-bold">{t('DownloadApp')}</span>{' '}
            </Button>
          </BasicDeepLink>
        </div>
      </div>
      <div className="flex h-full items-end justify-center">
        <Image
          src={PikAppLogo}
          alt="pik"
          width={404}
          height={546}
          className="h-[546px] w-[404px]"
        />
      </div>
    </section>
  );
};

export default DownloadApp;
